import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/AssetDowntimeDetailReport/Filter'

export default createListViewComponent({
  entityName: entityNames.assetDowntimeDetailReport,
  filterTemplateType: 'AssetDowntimeDetailReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
